import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ActionSheetController, LoadingController } from 'ionic-angular';
import { UserProvider } from '../../providers/user/user.provider';
import { ReportsProvider } from '../../providers/reports/reports';

/**
 * Generated class for the UserPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-user',
  templateUrl: 'user.html',
})
export class UserPage {
  user:any;
  user_uid: any;
  currentUser: any;
  loader: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private actionSheetCtrl: ActionSheetController,
    public userProvider: UserProvider,
    public reportProvider: ReportsProvider
  ) {
    this.user_uid = this.navParams.get('user_uid');
    this.user = this.navParams.get('user');
  }

  ionViewDidEnter(){
    this.refresh();
  }

  async refresh(){
    this.currentUser = await this.userProvider.getUser();
    this.user = await this.userProvider.getUser(this.user.uid);
    console.log("this.user",this.user);
  }

  sendReport(){
    this.presentLoading("Envoi du signalement ...");
    this.reportProvider.sendRepport(this.currentUser.uid, 'user', this.user);
    setTimeout(() => {
      this.loader.dismiss();
    },1000);
  }

  hideLoading() {
    this.loader.dismiss();
  }
  presentLoading(message) {
    this.loader = this.loadingCtrl.create({
      content: message
    });
    this.loader.present();
  }

  presentActionSheet() {

    let buttons = [];
    buttons.push({
      text: "Signaler l'utilisateur",
      role: "destructive",
      handler: () => {
        console.log("Destructive clicked");
        this.sendReport();
      }
    });

    buttons.push({
      text: "Annuler",
      role: "cancel",
      handler: () => {
        console.log("Cancel clicked");
      }
    });

    let actionSheet = this.actionSheetCtrl.create({
      title: 'Options',
      buttons: buttons
    });

    actionSheet.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/user/user.ts